module.exports = __webpack_public_path__ + "static/img/newLoad_career_bg1.1fce998.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/download/newLoad_career_bg1.png
// module id = 4RWv
// module chunks = 3